import { Component, OnInit } from '@angular/core';
import { ColDef, ISetFilterParams } from 'ag-grid-enterprise';
import { CellRendererService } from 'src/app/common/ag-grid-table/cell-renderers/dynamic.cell-renderer'
import { OptionsParams, UtilitiesService } from 'src/app/common/services/utilities.service';
import { AgGridToolsService } from 'src/app/common/ag-grid-table/services/ag-grid-tools.service';
import { BuildType } from 'src/app/enums/build-type';
import { getDefaultTableColumns } from 'src/app/common/ag-grid-table/default-table-columns';
import { TextCellRendererComponent } from 'src/app/common/ag-grid-table/cell-renderers/render-components/text/text.component';
import { RichTextEditorComponent } from 'src/app/common/ag-grid-table/cell-editors/rich-text/rich-text.component';
import { MiscAssetCellRendererComponent } from 'src/app/common/ag-grid-table/cell-renderers/render-components/misc-asset/misc-asset.component';
import { BooleanEditorComponent } from 'src/app/common/ag-grid-table/cell-editors/boolean/boolean.component';
import { MultiselectEditorComponent } from 'src/app/common/ag-grid-table/cell-editors/multiselect/multiselect.component';
import { DropdownEditorComponent } from 'src/app/common/ag-grid-table/cell-editors/dropdown/dropdown.component';
import { AssetTypes } from 'src/app/entities/enums/AssetTypes';
import { RefsCellRendererComponent } from 'src/app/common/ag-grid-table/cell-renderers/render-components/refs/refs.component';

@Component({
  selector: 'app-qa-user-groups-table',
  templateUrl: './qa-user-groups-ag-grid.component.html',
  styleUrls: ['./qa-user-groups-ag-grid.component.sass']
})
export class QaUserGroupsAgGridComponent implements OnInit {

  public entity: string = 'qa-user-groups';
  public columnDefs: ColDef[] = [];
  public bulkUpdateColDefs: any[] = [];
  public columnSelection: string;
  public autopopulateSelect: string = '';
  public buildParams: any = {};
  public tableParams: any = {};

  private options: any = {};

  constructor(
    private cellRendererService: CellRendererService,
    private utilitiesService: UtilitiesService,
    private agGridToolsService: AgGridToolsService,
  ) {
    this.autopopulateSelect = '';
  }

  async ngOnInit(): Promise<void> {

    await this.setOptions();
    const defaultColumns = getDefaultTableColumns(this.entity, this.agGridToolsService);

    this.columnDefs = [
      ...defaultColumns,
      {
        headerName: 'Name',
        field: 'name',
        cellRenderer: TextCellRendererComponent,
        sortable: true,
        unSortIcon: true,
        resizable: true,
        filter: 'agTextColumnFilter',
        floatingFilter: true,

        autoHeight: true,
        cellEditor: 'agTextCellEditor',
        type: 'editableColumn',
      },
      // {
      //   headerName: 'Users',
      //   field: 'users_ref',
      //   cellRenderer: RefsCellRendererComponent,
      //   cellRendererParams: {
      //     entity: 'qa-users',
      //     isArray: true,
      //   },
      //   sortable: true,
      //   unSortIcon: true,
      //   resizable: true,
      //   filter: 'agSetColumnFilter',
      //   filterParams: {
      //     values: this.options.users_ref,
      //     valueFormatter: (params: any) => {
      //       console.log(params.value);
      //       return `${params.value.identifier} (${params.value.id})`;
      //     },
      //     keyCreator: (params: any) => {
      //       return params.value._id;
      //     },
      //     comparator: this.agGridToolsService.nameASC,
      //     isMultiRefFilter: true,
      //     addEmptyFilters: true,
      //     populate: true,
      //     select: 'id identifier'
      //   },
      //   floatingFilter: true,
      //   cellEditor: MultiselectEditorComponent,
      //   type: 'editableColumn',
      //   cellEditorParams: {
      //     optionValue: "_id",
      //     optionLabel: "identifier",
      //     objectValue: true
      //   },
      //   width: 450,
      //   autoHeight: true,
      // },
      {
        headerName: 'QA Users',
        field: 'users_ref',
        cellRenderer: RefsCellRendererComponent,
        cellRendererParams: {
          entity: 'qa-users',
          isArray: true,
        },
        sortable: true,
        unSortIcon: true,
        resizable: true,
        filter: 'agSetColumnFilter',
        filterParams: {
          values: this.options.users_ref,
          valueFormatter: (params: any) => {
            return `${params.value.identifier} (${params.value.id})`;
          },
          keyCreator: (params: any) => {
            return params.value._id;
          },
          comparator: this.agGridToolsService.nameASC,
          isMultiRefFilter: true,
          addEmptyFilters: true,
          populate: true,
          select: 'id identifier'
        },
        floatingFilter: true,
        cellEditor: MultiselectEditorComponent,
        type: 'editableColumn',
        cellEditorParams: {
          optionValue: "_id",
          optionLabel: "identifier",
          objectValue: true
        },
        width: 450,
        autoHeight: true,
      },
    ]

    this.bulkUpdateColDefs = [
      {
        name: 'Name', id: 'name', type: 'text'
      },
      {
        name: 'Users', id: 'users', type: 'multiselect', isFlatList: true
      },
    ];

    this.buildParams = {

    }

    this.tableParams = {
      customActionsLabel: 'Custom Bulk Actions',
      customActionButtons: ['bulkLocalize'],
      localizeCollectionName: 'qa-user-groups',
    }


    this.columnSelection = this.agGridToolsService.getColumnFieldNamesFromCols(this.columnDefs);

  }

  async setOptions(){
    const entities = [
      { ref: 'users_ref', entity: 'qa-users', select: 'id _id identifier'},
    ];

    for (const { ref, entity, select} of entities) {
      const params = new OptionsParams({
        entity, select,
      });
      await this.utilitiesService.getOptions(this.options, ref, params);;
    }

  }

}
